export default "__VITE_ASSET__U_OFVMOJ__"